import React from "react"

const SubText = () => (
    <div className="subText">

        I'm a Software Engineer that loves front-end development and 
        technologies. My current adventure has me focusing on <b>C#, 
        JavaScript, .NET MVC, HTML, CSS,</b> and<b> JQuery</b>. 
        I'm currently teaching myself the basics of modern JavaScript 
        frameworks with <b>Angular and React</b> so watch my GitHub for an upcoming 
        project. I'm constantly tinkering and love how programming allows me
        to be both technical and creative.

    </div>
)

export default SubText